module.exports = __webpack_public_path__ + "img/Free-trial-API.cf2fc07c.gif";